export type HealthChipTone = 'checking' | 'healthy' | 'advisory' | 'degraded' | 'stale' | 'unknown';

export function chipToneAfterRefresh(input: {
  hasData: boolean;
  loading: boolean;
  error: string | null;
  healthy: boolean;
  advisory?: boolean;
  lastSuccessAt?: string | null;
}): HealthChipTone {
  if (input.loading && !input.hasData && !input.error) return 'checking';
  if (input.error && input.hasData) return 'stale';
  if (input.error) return 'unknown';
  if (!input.hasData) return 'unknown';
  if (input.advisory && input.healthy) return 'advisory';
  if (input.healthy) return 'healthy';
  return 'degraded';
}

export function incidentPipelineChipLabel(tone: HealthChipTone, lastSuccessAt?: string | null): string {
  switch (tone) {
    case 'checking':
      return 'Incident pipeline: Checking…';
    case 'healthy':
      return 'Incident pipeline: OK';
    case 'advisory':
      return 'Incident pipeline: Advisory';
    case 'degraded':
      return 'Incident pipeline: Degraded';
    case 'stale':
      return lastSuccessAt
        ? `Incident pipeline: STALE · last success ${lastSuccessAt}`
        : 'Incident pipeline: STALE';
    default:
      return 'Incident pipeline: Unknown';
  }
}

export function cameraViewStaleLabel(lastSuccessAt?: string | null): string {
  return lastSuccessAt
    ? `Camera view: STALE · last success ${lastSuccessAt}`
    : 'Camera view: STALE';
}
